//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionText,
  Illustration,
  Modal,
  Typography,
} from '@backmarket/design-system'
import get from 'lodash.get'
import isEmpty from 'lodash.isempty'
import Vue from 'vue'
import { mapGetters } from 'vuex'

import { getFetchInstallmentSimulation } from '@http/endpoints'
import FormattedMessage from '@i18n/components/FormattedMessage'
import Picker from '@product/components/Picker'

import { InstallmentSimulation } from '../../form'
import {
  PaymentMethodGroup,
  paymentGroupIcon,
  paymentGroupLabel,
} from '../../methods'

import translations from './InstallmentSimulationModal.translations'

export default {
  components: {
    ActionText,
    FormattedMessage,
    Illustration,
    InstallmentSimulation,
    Modal,
    Picker,
    Typography,
  },

  props: {
    name: {
      type: String,
      default: 'InstallmentSimulationModal',
    },

    paymentGroupId: {
      type: String,
      required: true,
    },

    paymentMethods: {
      type: Array,
      default: null,
    },

    /**
     * @typedef {import('@http/transformResponse/transformResponse').Price}
     */
    basePrice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedMethodIndex: -1,
      simulations: {},
    }
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      country: 'config/country',
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),

    groupLabel() {
      return paymentGroupLabel(this.paymentGroupId)
    },

    groupIcon() {
      return paymentGroupIcon(this.paymentGroupId)
    },

    steps() {
      return [
        {
          title: translations.step1Title,
          description: translations.step1Description,
          withIcon: true,
        },
        {
          title: translations.step2Title,
          description: translations.step2Description,
          withIcon: true,
        },
        {
          title: translations.step3Title,
          description: translations.step3Description,
          withIcon: false,
        },
      ]
    },

    paymentGroup() {
      const methods = this.paymentMethods || this.countryPaymentMethods

      return (
        PaymentMethodGroup.fromAvailableMethods(methods).find(
          (group) => group.id === this.paymentGroupId,
        ) || new PaymentMethodGroup({}, [])
      )
    },

    hasManyMethods() {
      return this.paymentGroup.methods.length > 1
    },

    selectedMethod() {
      return this.paymentGroup.methods[this.selectedMethodIndex]
    },

    installmentCount() {
      return get(this.selectedMethod, 'installmentCount', 0)
    },

    simulationKey() {
      return [
        this.basePrice.currency,
        this.basePrice.amount,
        this.installmentCount,
      ].join('/')
    },

    simulation() {
      return this.simulations[this.simulationKey]
    },

    footerValues() {
      return get(this.paymentGroup, `config.legalNotices[${this.country}]`)
    },

    hasFooterValues() {
      return !isEmpty(this.footerValues)
    },
  },

  watch: {
    selectedMethodIndex() {
      this.updateSimulation()
    },
  },

  methods: {
    handleOpen() {
      this.selectedMethodIndex = 0
    },

    async updateSimulation() {
      if (this.installmentCount > 0 && !this.simulations[this.simulationKey]) {
        const { payload } = await this.$store.dispatch('http/request', {
          request: getFetchInstallmentSimulation(this.basePrice.currency),
          queryParams: {
            payment_method: this.selectedMethod.bmCode,
            amount: this.basePrice.amount,
            nb_installments: this.installmentCount,
            country_code: this.country,
          },
        })

        Vue.set(this.simulations, this.simulationKey, payload)
      }
    },

    isSelected(index) {
      return index === this.selectedMethodIndex
    },

    handleSelectMethod(index) {
      this.selectedMethodIndex = index
    },
  },
}
